import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

/**
 * Breadcrumb HTML crawlable avec Schema.org BreadcrumbList
 * SEO-friendly : liens <a href> + JSON-LD
 */
const BreadcrumbSEO = ({ items }) => {
  // Générer le JSON-LD BreadcrumbList
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.label,
      "item": item.url ? `https://orion-industrie.eu${item.url}` : undefined
    }))
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>

      <nav aria-label="Breadcrumb" className="bg-gray-50 border-b py-3">
        <div className="container mx-auto px-4">
          <ol className="flex items-center text-sm text-gray-600 flex-wrap" itemScope itemType="https://schema.org/BreadcrumbList">
            {items.map((item, index) => (
              <li
                key={index}
                className="flex items-center"
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                {item.url ? (
                  <>
                    <Link
                      to={item.url}
                      className="hover:text-[#FF6600] transition-colors"
                      itemProp="item"
                    >
                      <span itemProp="name">{item.label}</span>
                    </Link>
                    <meta itemProp="position" content={index + 1} />
                  </>
                ) : (
                  <>
                    <span className="text-[#020d2a] font-medium truncate" itemProp="name">
                      {item.label}
                    </span>
                    <meta itemProp="position" content={index + 1} />
                  </>
                )}
                
                {index < items.length - 1 && (
                  <ChevronRight className="w-4 h-4 mx-2 flex-shrink-0" />
                )}
              </li>
            ))}
          </ol>
        </div>
      </nav>
    </>
  );
};

export default BreadcrumbSEO;
